const NewInvoiceIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9999 16.6667V14.3333M11.9999 14.3333V12M11.9999 14.3333H9.8571M11.9999 14.3333H14.1428M12.7142 5.00068C12.646 5 12.5694 5 12.4819 5H9.28582C8.48576 5 8.08543 5 7.77984 5.16955C7.51104 5.31868 7.29266 5.55648 7.1557 5.84918C7 6.18193 7 6.61785 7 7.48904V16.5113C7 17.3825 7 17.8178 7.1557 18.1506C7.29266 18.4433 7.51104 18.6815 7.77984 18.8306C8.08513 19 8.48498 19 9.2835 19L14.7164 19C15.5149 19 15.9142 19 16.2194 18.8306C16.4882 18.6815 16.7073 18.4433 16.8443 18.1506C16.9999 17.8181 16.9999 17.3834 16.9999 16.5139V9.91998C16.9999 9.82452 16.9998 9.74103 16.9992 9.66667M12.7142 5.00068C12.9182 5.0027 13.0473 5.01077 13.1705 5.04298C13.3163 5.08109 13.4555 5.14409 13.5833 5.22938C13.7275 5.32555 13.8512 5.4603 14.0981 5.72917L16.3306 8.1601C16.5776 8.42913 16.7005 8.56328 16.7888 8.72026C16.8672 8.85944 16.9251 9.0112 16.9601 9.16992C16.9897 9.30403 16.9972 9.44462 16.9992 9.66667M12.7142 5.00068V7.17778C12.7142 8.04897 12.7142 8.48426 12.8699 8.81701C13.0069 9.10971 13.2253 9.34815 13.494 9.49729C13.7993 9.66667 14.1992 9.66667 14.9977 9.66667H16.9992M16.9992 9.66667H17"
      stroke="#447AED"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NewInvoiceIcon;
